import React, { useEffect, useState } from "react";
import "./navStrip.style.sass";
import linkData from "../../data/navBar/links.data.json";
import { Icon, Nav } from "rsuite";
import { createStructuredSelector } from "reselect";
import { selectActiveLink } from "../../redux/site/site.selector";
import { ChangeActiveLink } from "../../redux/site/site.actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Setting } from "../../setting";

const NavStrip = ({ active, changeActive, history }) => {
  const [dLink, setDLink] = useState("https://newgps.xitonix.com/");

  useEffect(() => {
    handleMount();
  }, []);

  async function handleMount() {
    axios.get(`${Setting.apiUrl}api/setting/list`).then(res => {
      setDLink(res.data.track_plan_address);
    });
  }

  return (
    <div className="navStipe">
      <div className="fix-icon">
        <Icon icon="map-marker" />
      </div>
      <Nav activeKey={active} onSelect={activeKey => changeActive(activeKey)}>
        {linkData.map(item => {
          if (item.id < 10 || Number(item.id) === 15) {
            const data = {
              id: "2",
              text: "پنل ردیابی",
              icon: "safari",
              activeKey: "tracking",
            };

            if (item.id === "2") {
              return (
                <Nav.Item
                  onClick={() => {
                    if (data.activeKey === "tracking") {
                      window.location.href = dLink;
                    } else if (data.activeKey === "home") {
                      changeActive(data.activeKey);
                      history.push("/");
                    } else {
                      changeActive(data.activeKey);
                      history.push(`/${item.activeKey}`);
                    }
                  }}
                  className="nav-items"
                  id={data.activeKey}
                  key={data.id}
                  eventKey={data.activeKey}
                >
                  {data.text ? data.text : null}
                </Nav.Item>
              );
            }
            return (
              <Nav.Item
                onClick={() => {
                  if (item.activeKey === "tracking") {
                    window.location.href = item.link;
                  } else if (item.activeKey === "home") {
                    changeActive(item.activeKey);
                    history.push("/");
                  } else {
                    changeActive(item.activeKey);
                    history.push(`/${item.activeKey}`);
                  }
                }}
                className="nav-items"
                id={item.activeKey}
                key={item.id}
                eventKey={item.activeKey}
              >
                {item.text ? item.text : null}
              </Nav.Item>
            );
          }
          return null;
        })}
      </Nav>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  active: selectActiveLink,
});
const mapDispatchToProps = dispatch => ({
  changeActive: activeKey => dispatch(ChangeActiveLink(activeKey)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavStrip)
);
